import { Offer_type } from "./offer.types";

export type userInfo = {
    name: string;
    lastname: string;
    email: string;
    phoneNumber: string;
    error?: {
        email?: string;
        lastname?: string;
        name?: string;
        phoneNumber?: string;
    };
};

export type companyInfo = {
    siret: string;
    siren: string;
    vatNumber: string;
    name: string;
    legalUnitName: string;
    tradeName: string;
    address: string;
    city: string;
    postalCode: string;
    country: string;
    legalForm: string;
    activities: string[];
    salesAccounts: string[];
    error?: {
        siret?: string;
        siren?: string;
        vatNumber?: string;
        name?: string;
        legalUnitName?: string;
        tradeName?: string;
        address?: string;
        city?: string;
        postalCode?: string;
        country?: string;
        legalForm?: string;
    };
};

export type accountingInfo = {
    incomeCategory: string;
    taxRegime: string;
    accountingType: string;
    payedVAT: boolean;
};

export type declarationInfo = {
    vatSystem: string;
    vatDeclarationDay: number;
    vatOption: string;
    taxSystemType: string;
    sie: string;
    startBusinessDate: string;
    firstAccountingPeriodEnd: string;
};

export type registrationInfo = {
    user: userInfo;
    company: companyInfo;
    accounting: accountingInfo;
    declaration: declarationInfo;
    offer: Offer_type;
};

export enum Register_Step {
    USER_STEP = 0,
    COMPANY_STEP = 1,
    ACCOUNTING_STEP = 3,
    OFFER_STEP = 2,
    DECLARATION_STEP = 6,
    RESUME_STEP = 4,
    END_STEP = 5,
}
